// ======================================================================
// File Name       : item
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { END_CONDITION_TYPE_FOR_ITEM, PUBLIC_STATUS, CHOSEN_THUMBNAIL_CONTENT, START_CONDITION_TYPE_FOR_ITEM } from '../constants/ItemConstant';
import { MODE } from '../constants';
import * as ActionTypes from '../constants/actionTypes/item';
import * as utils from '../utils';
import { CONTENT_DRILL_TYPE } from '../constants/ContentConstant';
import ItemDocumentThumbnail from '../images/item_document_thumbnail.svg';
import ItemVideoThumbnail from '../images/item_video_thumbnail.svg';
import { PUBLIC_PERIOD_TYPE } from '../constants/CourseConstants';
import * as courseUtils from '../utils/CourseUtils';

const INIT_ITEM = {
  parentBoxSecernId: '',
  itemName: '',
  description: '',
  publicStatus: PUBLIC_STATUS.PUBLIC,
  imageFileSelectType: CHOSEN_THUMBNAIL_CONTENT.DEFAULT,
  contentInfo: {
    contentSecernId: '',
    contentType: '',
  },
  endConditionTypeForItem: END_CONDITION_TYPE_FOR_ITEM.ACHIVEMENT_RATE,
  progressRatioForItemEnd: 0,
  imageUploadFile: null,
  limitPublicPeriod: PUBLIC_PERIOD_TYPE.NO_LIMIT,
  publicPeriodFrom: '',
  publicPeriodTo: '',
  // sprint_20230522_tma START
  startConditionTypeForItem: START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION,
  progressRatioForItemStart: 0,
  selectedItemList: [],
  // sprint_20230522_tma END
};

const initialState = {
  items: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
    startPosition: 0,
  },
  editMode: MODE.EDIT_MODE,
  edittingItem: {},
  selectedItemList: [], // sprint_20230522_tma
};

export default function item(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ITEM_RECEIVE_ITEM_LIST: {
      const { recordNum, itemList } = action;
      const items = itemList.reduce(
        (acc, cur) => {
          const { itemSecernId } = cur;
          acc.bySecernId[itemSecernId] = cur;
          acc.allSecernIds.push(itemSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
          recordNum,
        },
      );

      return {
        ...state,
        ...{ items },
      };
    }

    //
    case ActionTypes.ITEM_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG: {
      const { advanceSettingExpand, userAttributeExpanded } = initialState;
      const { itemSecernId, isItemReport } = action;
      // sprint_20230522_tma START
      const selectedItemList = [];
      // sprint_20230522_tma END
      let noLimitTo = true;
      let noLimitFrom = true;
      if (state.items.bySecernId && state.items.bySecernId[itemSecernId]) {
        const { publicPeriodFrom, publicPeriodTo, itemListForItemStart } = state.items.bySecernId[itemSecernId];
        const limitationInfoPublicPeriod = courseUtils.getLimitationInfoPublicPeriod(
          publicPeriodFrom,
          publicPeriodTo,
        );
        noLimitTo = limitationInfoPublicPeriod.noLimitTo;
        noLimitFrom = limitationInfoPublicPeriod.noLimitFrom;
        // sprint_20230522_tma START
        for (let i = 0; i < itemListForItemStart.length; i++) {
          const newItemList = {
            itemSecernId: itemListForItemStart[i],
            addNew: true,
          };
          selectedItemList.unshift(newItemList);
        }
        // sprint_20230522_tma END
      }

      const edittingItem = {
        ...state.items.bySecernId[itemSecernId],
        isItemReport,
        imageFileSelectType: CHOSEN_THUMBNAIL_CONTENT.NOTHING,
        imageUploadFile: null,
        limitPublicPeriod: noLimitTo && noLimitFrom ? PUBLIC_PERIOD_TYPE.NO_LIMIT : PUBLIC_PERIOD_TYPE.LIMIT,
      };

      return {
        ...state,
        edittingItem,
        editMode: MODE.EDIT_MODE,
        selectedItemList, // sprint_20230522_tma
        advanceSettingExpand,
        userAttributeExpanded,
      };
    }

    //
    case ActionTypes.ITEM_INIT_DATA_FOR_REGISTER_DIALOG: {
      const { payload } = action;
      const edittingItem = { ...INIT_ITEM, ...payload, limitPublicPeriod: PUBLIC_PERIOD_TYPE.NO_LIMIT };
      const { detailSettingExpanded, userAttributeExpanded } = initialState;

      return {
        ...state,
        edittingItem,
        editMode: MODE.NEW_MODE,
        detailSettingExpanded,
        userAttributeExpanded,
      };
    }

    //
    case ActionTypes.ITEM_UPDATE: {
      const { payload } = action;
      const edittingItem = { ...state.edittingItem, ...payload };
      return {
        ...state,
        edittingItem,
      };
    }

    //
    case ActionTypes.ITEM_RECIEVE_LINKING_CONTENT: {
      const { contentInfo: { contentName, contentSecernId, contentType, drillTypeForItem } } = action;
      const parentBoxSecernId = state.edittingItem ? state.edittingItem.parentBoxSecernId : '';
      const edittingItem = {
        ...INIT_ITEM,
        itemName: contentName,
        contentInfo: {
          contentSecernId,
          contentType,
          drillTypeForItem,
        },
        isItemReport: drillTypeForItem === CONTENT_DRILL_TYPE.CORRECTION_MODE,
        parentBoxSecernId,
      };
      return {
        ...state,
        edittingItem,
        editMode: MODE.NEW_MODE,
      };
    }
    case ActionTypes.ITEM_CHANGE_DATA: {
      const { items } = state;
      const { data } = action;
      const { bySecernId } = items;
      try {
        const itemSecernId = state.edittingItem.itemSecernId;
        let thumbnailUrl = null;
        if (bySecernId && bySecernId[itemSecernId] && bySecernId[itemSecernId].thumbnailUrl) {
          if (data === CHOSEN_THUMBNAIL_CONTENT.NOTHING) {
            thumbnailUrl = bySecernId[itemSecernId].thumbnailUrl;
          }
        }
        const edittingItem = {
          ...state.edittingItem,
          thumbnailUrl,
        };
        return {
          ...state,
          edittingItem,
        };
      } catch (err) {
        return err;
      }
    }
    case ActionTypes.ITEM_GET_THUMBNAIL_DEFAULT: {
      const { data } = action;
      let defaultThumbnail = null;
      try {
        if (data && data.imageList && data.imageList.length && data.imageList[0].thumbnailUrl) {
          defaultThumbnail = data.imageList[0].thumbnailUrl;
        }
      } catch (err) {
        return err;
      }
      const edittingItem = {
        ...state.edittingItem,
        defaultThumbnail,
      };
      return {
        ...state,
        edittingItem,
      };
    }
    case ActionTypes.ITEM_GET_VIDEO_THUMBNAIL_DEFAULT: {
      const { data } = action;
      let defaultThumbnail = null;
      if (data && data.videoThumbnailInfo && data.videoThumbnailInfo.videoThumbnailUrl) {
        defaultThumbnail = data.videoThumbnailInfo.videoThumbnailUrl;
      } else {
        defaultThumbnail = ItemVideoThumbnail; // Step 10.0.0
      }
      const edittingItem = {
        ...state.edittingItem,
        defaultThumbnail,
      };
      return {
        ...state,
        edittingItem,
      };
    }
    case ActionTypes.ITEM_GET_DOCUMENT_THUMBNAIL_DEFAULT: {
      const { data } = action;
      let defaultThumbnail = null;
      if (data && data.imageUrl) {
        defaultThumbnail = data.imageUrl;
      } else {
        defaultThumbnail = ItemDocumentThumbnail; // Step 10.0.0
      }
      const edittingItem = {
        ...state.edittingItem,
        defaultThumbnail,
      };
      return {
        ...state,
        edittingItem,
      };
    }
    case ActionTypes.ITEM_SAVE_DETAIL_SETTING_STATE: {
      const { name, value } = action;
      return {
        ...state,
        [name]: value,
      };
    }
    default:
      return state;
  }
}
